import graphql__446f6d75cb3093a54e27 from "./__generated__/Answer_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import ShallowAnswer, { SHALLOW_ANSWER_TYPES } from "./ShallowAnswer";
import AnswerAddress from "./AnswerAddress";
import AnswerBudget from "./AnswerBudget";
import { useAnswerShouldBeConditionnallyHidden } from "./useAnswerShouldBeConditionnallyHidden";

const AnswerTypes = {
  AnswerAddress,
  AnswerBudget
};

const Answer = props => {
  const answer = useFragment(Answer_answer, props.answer);
  const typename = answer.__typename;
  const isShallowAnswer = SHALLOW_ANSWER_TYPES[typename];
  const AnswerType = isShallowAnswer ? ShallowAnswer : AnswerTypes[typename];

  // Check whether there are form field display conditions that may hide the current
  // answer field.
  //
  // Note that this is not used when the answer is rendered through the `<Answers>`
  // component as it already filters out hidden answers, but is here to allow answers
  // to be rendered manually but still use the conditionnal hiding mechanism.
  const shouldBeHidden = useAnswerShouldBeConditionnallyHidden({ answer });
  if (shouldBeHidden) return null;

  return (
    <AnswerType
      isCorrection={props.isCorrection}
      correctionTextOnlyOnWrongAnswers={props.correctionTextOnlyOnWrongAnswers}
      resourceId={props.resourceId}
      answer={answer}
    />
  );
};

const Answer_answer = graphql__446f6d75cb3093a54e27;

const AnswerContainer = Answer;

export default AnswerContainer;
